import { Alert } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import VehicleOperations, {
  VehicleOperationsTabs,
} from "@/common/components/EntityComposed/Operations/VehicleOperations";
import { ViewVariant } from "@/common/ts/layout";
import { RepairOperationDto } from "@/core/api/generated/v1";

interface Props {
  repairOperation: RepairOperationDto;
}

export default function RelatedOperationsTabContent({ repairOperation }: Props) {
  return (
    <PageTabContent gap={0}>
      <Alert
        severity='info'
        sx={{
          borderRadius: 0,
          borderRight: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        Here you can see related operations. For instance, operations for the same damages or
        operations that are in the same context.
      </Alert>

      <VehicleOperations
        vehicleId={repairOperation.vehicle?.id}
        anyVehicleDamageIds={repairOperation.items
          ?.map((x) => x.damage?.id || "")
          .filter((x) => !!x)}
        displayProps={{
          header: false,
          filters: false,
          viewVariant: ViewVariant.Tab,
        }}
        excludeTabs={[
          VehicleOperationsTabs.RepairOperations,
          VehicleOperationsTabs.AccessoryChecks,
        ]}
      />
    </PageTabContent>
  );
}
